/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { WithVersionItemRequestBuilderNavigationMetadata, WithVersionItemRequestBuilderRequestsMetadata } from './item/index.js';
/**
 * Uri template for the request builder.
 */
export const ClientsRequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}/clients";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ClientsRequestBuilderNavigationMetadata = {
    byVersion: {
        requestsMetadata: WithVersionItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithVersionItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["version"],
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map